import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import { materialTableMui412CompatComponents } from '../../utils/materialTableMui412Compat';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import ClearIcon from '@material-ui/icons/Clear';
import BuildIcon from '@material-ui/icons/Build';
import DoneIcon from '@material-ui/icons/Done';
import { instanceAxios } from '../../InstanceAxios';
import environment from '../../environment';
import api from '../../environment';

function Mensal(props) {
  const [idAtividade, setIdAtividade] = useState(props.match.params.id);
  const [atividade, setAtividade] = useState({});
  const [mes, setMes] = useState(props.match.params.mes);
  const [ano, setAno] = useState(props.match.params.ano);
  const [opcoes, setOpcoes] = useState({
    1: (
      <PriorityHighIcon
        style={{ color: '#FFFF00' }}
        title="Em Andamento"
        name="Em Andamento"
      />
    ),
    2: <ClearIcon style={{ color: '#FF0000' }} />,
    3: <BuildIcon style={{ color: '#ADFF2F' }} />,
    4: <DoneIcon style={{ color: '#008000' }} />,
  });
  const [columns, setColumns] = useState([
    { title: 'Nome', field: 'nome', editable: 'never' },
    {
      title: 'Nome Empresarial',
      field: 'UsuarioEmpresa.Empresa.razao_social',
      editable: 'never',
    },
    { title: 'CNPJ', field: 'UsuarioEmpresa.Empresa.cnpj', editable: 'never' },
    {
      title: 'Tipo tributação',
      field: 'UsuarioEmpresa.Empresa.TipoEmpresa.nome',
      editable: 'never',
    },
    {
      title: 'Cidade',
      field: 'UsuarioEmpresa.Empresa.cidade',
      editable: 'never',
    },
    {
      title: 'Estado',
      field: 'UsuarioEmpresa.Empresa.estado',
      editable: 'never',
    },
    {
      title: 'Emissão Notas',
      field: 'AtividadeMensal.emissao_notas',
      lookup: opcoes,
    },
    {
      title: 'Livro Fiscal',
      field: 'AtividadeMensal.livro_fiscal_rel',
      lookup: opcoes,
    },
    {
      title: 'DAS',
      field: 'AtividadeMensal.das_simples',
      lookup: opcoes,
    },
    {
      title: 'PARCELAMENTO',
      field: 'AtividadeMensal.parcelamento',
      lookup: opcoes,
    },
    {
      title: 'PIS/CONFIS',
      field: 'AtividadeMensal.pis_confis',
      lookup: opcoes,
    },
    {
      title: 'IRPJ/CSLL',
      field: 'AtividadeMensal.irpj_csll',
      lookup: opcoes,
    },
    {
      title: 'DCTF',
      field: 'AtividadeMensal.dctf',
      lookup: opcoes,
    },
    {
      title: 'SPED CONT',
      field: 'AtividadeMensal.sped_cont',
      lookup: opcoes,
    },
    {
      title: 'CND PREFEITURA',
      field: 'AtividadeMensal.cnd_prefeitura',
      lookup: opcoes,
    },
    {
      title: 'CND RECEITA',
      field: 'AtividadeMensal.cnd_receita',
      lookup: opcoes,
    },
    {
      title: 'GFIP',
      field: 'AtividadeMensal.gfip',
      lookup: opcoes,
    },
    {
      title: 'ISS',
      field: 'AtividadeMensal.iss',
      lookup: opcoes,
    },
    {
      title: 'Situação',
      field: 'AtividadeMensal.status_atividade',
      lookup: {
        1: 'Sem Movimentação',
        2: 'Realizado',
        3: 'Outra Praça',
      },
    },
    {
      title: 'Data entrega',
      field: 'AtividadeMensal.data_entrega',
      type: 'date',
    },
  ]);

  const handleMes = (event) => {
    window.location = `/atividadeMensal/${idAtividade}/${event.target.value}/${ano}`;
  };

  const handleAno = (event) => {
    window.location = `/atividadeMensal/${idAtividade}/${mes}/${event.target.value}`;
  };

  useEffect(() => {
    const fetchAtividades = async () => {
      await instanceAxios(localStorage.getItem('toobiauth'))
        .get(`/atividades/${idAtividade}`)
        .then((res) => {
          setAtividade(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    fetchAtividades();
  }, []);

  return (
    <>
      <Typography
        component="h3"
        variant="h3"
        align="left"
        color="textPrimary"
        gutterBottom
      >
        {atividade.nome}
      </Typography>
      <Typography variant="h5" align="left" color="textSecondary" component="p">
        {atividade.praca}
      </Typography>
      <Grid
        container
        spacing={1}
        justify="left"
        alignItems="left"
        style={{ paddingTop: '3%' }}
      >
        <Grid item xs={6} sm={3} md={3} lg={3}>
          <FormControl variant="outlined">
            <InputLabel>Mês</InputLabel>
            <Select value={mes} onChange={handleMes} label="Mês">
              <MenuItem value={1}>Janeiro</MenuItem>
              <MenuItem value={2}>Fevereiro</MenuItem>
              <MenuItem value={3}>Março</MenuItem>
              <MenuItem value={4}>Abril</MenuItem>
              <MenuItem value={5}>Maio</MenuItem>
              <MenuItem value={6}>Junho</MenuItem>
              <MenuItem value={7}>Julho</MenuItem>
              <MenuItem value={8}>Agosto</MenuItem>
              <MenuItem value={9}>Setembro</MenuItem>
              <MenuItem value={10}>Outubro</MenuItem>
              <MenuItem value={11}>Novembro</MenuItem>
              <MenuItem value={12}>Dezembro</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6} sm={3} md={3} lg={3}>
          <FormControl variant="outlined">
            <InputLabel>Ano</InputLabel>
            <Select value={ano} onChange={handleAno} label="Ano">
              <MenuItem value={2019}>2019</MenuItem>
              <MenuItem value={2020}>2020</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        justify="left"
        alignItems="left"
        style={{ paddingTop: '3%' }}
      >
        <TableContainer component={Paper}>
          <MaterialTable
            components={materialTableMui412CompatComponents}
            localization={{
              pagination: {
                labelDisplayedRows: '{from}-{to} de {count}',
              },
              toolbar: {
                nRowsSelected: '{0} linhas(s) selecionadas',
              },
              header: {
                actions: 'Ações',
              },
              body: {
                emptyDataSourceMessage: 'Sem dados para mostrar',
                filterRow: {
                  filterTooltip: 'Filtro',
                },
              },
            }}
            title="Atividade Mensais"
            columns={columns}
            data={(query) =>
              new Promise((resolve, reject) => {
                const url = `${api}/atividades/mensal/${
                  props.match.params.id
                }?mes=${mes}&ano=${ano}&offset=${Number(query.page)}&search=${
                  query.search
                }`;
                fetch(url, {
                  method: 'get',
                  headers: {
                    authorization: `Bearer ${localStorage.getItem(
                      'toobiauth'
                    )}`,
                  },
                })
                  .then((response) => response.json())
                  .then((result) => {
                    resolve({
                      data: result.atividadeMensalUsuarios,
                      page: result.page,
                      totalCount: result.count,
                    });
                  });
              })
            }
            editable={{
              onRowUpdate: (newData, oldData) =>
                new Promise(async (resolve, reject) => {
                  console.log('1');
                  await instanceAxios(localStorage.getItem('toobiauth'))
                    .post(
                      `${environment}/atividades/mensal`,
                      newData.AtividadeMensal
                    )
                    .then((res) => {
                      console.log(2);
                      console.log(res);
                      if (res) {
                        window.location.reload();
                      }
                    })
                    .catch((err) => {
                      console.log(err);
                      alert('Erro ao atualizar dados');
                      resolve();
                    });
                }),
            }}
          />
        </TableContainer>
      </Grid>
    </>
  );
}

export default Mensal;
